var _path, _path2, _path3, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmiley0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18c0 4.546-1.67 8.684-4.461 11.855-.828.94-1.74 1.796-2.736 2.553a17.91 17.91 0 01-8.095 3.396c-.884.112-1.796.196-2.708.196-9.933 0-18-8.053-18-18A17.949 17.949 0 018.404 2.778a16.866 16.866 0 013.423-1.684 17.984 17.984 0 0119.712 5.05A17.914 17.914 0 0136 18.001z",
    fill: "#ecad03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.164 19.263c.996 0 1.796-1.109 1.796-2.47 0-1.36-.8-2.469-1.796-2.469s-1.796 1.109-1.796 2.47c0 1.36.8 2.469 1.796 2.469zM23.823 19.263c.996 0 1.795-1.109 1.795-2.47 0-1.36-.8-2.469-1.795-2.469-.996 0-1.796 1.109-1.796 2.47 0 1.36.8 2.469 1.796 2.469z",
    fill: "#050000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.525 29.855A47.902 47.902 0 0033.012 18c0-4.083-.52-8.067-1.487-11.855A17.914 17.914 0 0135.986 18c0 4.531-1.655 8.684-4.461 11.855z",
    fill: "#d57e00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#050000",
    height: 2,
    rx: 1,
    width: 9,
    x: 13.5,
    y: 24
  })));
}

export default SvgSmiley0;